import React from 'react';

export const CustomIframe = ({ videoId }) => {
  return (
    <iframe
      height="315"
      src={videoId}
      title="YouTube video player"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowFullScreen
    />
  );
};
